import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { isAllowListOverrideVisible } from "../../../../store/banners/banners.selectors";
import { BannerInline } from "../../../../components/bannerInline/BannerInline";
import { hideAllowListOverrideWarning } from "../../../../store/banners/banners.actions";

import "./AllowListOverrideWarning.scss";

export const AllowListOverrideWarning = () => {
  const dispatch = useDispatch();
  const shouldShow = useSelector(isAllowListOverrideVisible);

  if (!shouldShow) return null;

  const hideAllowListPanel = () => dispatch(hideAllowListOverrideWarning());

  return (
    <BannerInline
      className={"allow-list-override-warning"}
      onClick={hideAllowListPanel}
      header={<FormattedMessage id="allow_list_override_security_domains" />}
      message={
        <FormattedMessage id="allow_list_override_security_domains_note" />
      }
    />
  );
};
